import React, { useState } from "react";

import "./MainScreen.scss";

import toothbrush from "./assets/img/toothbrush.png";

import { Header } from "../";

const MainScreen = () => {
  const [active, setActive] = useState(false);

  return (
    <>
      <main className="main">
        <Header />
        <div className="container">
          <div className="main-wrapper">
            <div className="main-info">
              <h1 className="main__title">
                Вторая жизнь{" "}
                <span className="main__title-margined">зубной щётки</span>
              </h1>

              <p className="main__subtitle">
                Давать вещам вторую жизнь – значит бережно и рационально
                относиться к ресурсам планеты. Старые пластиковые зубные щетки –
                хороший ресурс для создания новых полезных вещей.
              </p>

              <a
                href="#initiatives"
                className="button button--outlined main__button"
              >
                Узнать про наши инициативы
              </a>
            </div>
            <img
              className="main__toothbrush"
              src={toothbrush}
              alt="Зубная щетка"
            />
          </div>
        </div>
      </main>
    </>
  );
};

export default MainScreen;
